import { RouterProvider } from 'react-router-dom';
import { router } from './Components/route/Route';


function App() {
  return (
    <RouterProvider router={router}>
      
    </RouterProvider>
  );
}

export default App;
